import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import "./main.css"

//axios.defaults.baseURL = "https://localhost:7009/"
axios.defaults.baseURL = "http://eposplus.sytes.net/gymmanagementsolution/api/"
//axios.defaults.baseURL = "http://192.168.1.200/gymmanagementsystem/api/"
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token 

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
